<template>
  <div class="ex-checkpoint-banner">
    <div class="ex-checkpoint-banner-icon">
      <Icon
        v-if="missing_component === 'Instructions'"
        name="instructions_icon"
      />
      <Icon
        v-else-if="missing_component === 'Microlearning'"
        name="microlearning_icon"
      />
      <Icon
        v-else
        name="quiz_icon"
      />
    </div>
    <div class="ex-checkpoint-banner-right">
      <div v-if="missing_component === 'Instructions'">
        <p class="ex-checkpoint-banner-title">This Checkpoint has no instructions</p>
        <p class="ex-checkpoint-banner-description">
          Instructions enable coaches to rigorously inspect a checkpoint. In their absence, coaches rely on personal judgment to interpret the criteria and assess
          readiness, which can lead to inconsistencies in inspection outcomes.
        </p>
        <p class="ex-checkpoint-banner-description">
          Instructions also help employees prepare more effectively for inspections by providing clarity on the criteria and how they will be inspected.
        </p>
      </div>
      <div v-if="missing_component === 'Microlearning'">
        <p class="ex-checkpoint-banner-title">This Checkpoint has no microlearning video</p>
        <p class="ex-checkpoint-banner-description banner-description">
          Microlearning videos are short, targeted resources that help employees quickly grasp key concepts and best practices. Adding a video to this checkpoint will help employees prepare for inspections.
        </p>
      </div>
      <div v-if="missing_component === 'Quiz'">
        <p class="ex-checkpoint-banner-title">This Checkpoint has no Quiz</p>
        <p class="ex-checkpoint-banner-description banner-description">
          Quizzes help employees test their knowledge and reinforce learning. Adding a quiz to this checkpoint will help employees prepare for inspections.
        </p>
      </div>
      <div class="ex-checkpoint-banner-buttons">
        <Button
          size="small"
          :secondary="true"
          :label="`Add ${missing_component === 'Microlearning' ? missing_component + ' Video' : missing_component}`"
          class="banner-btns"
          :class="{
            'add-instructions': missing_component === 'Instructions',
            'add-microlearning': missing_component === 'Microlearning',
            'add-quiz': missing_component === 'Quiz',
          }"
          @onClick="handleAddClick"
        ></Button>
        <AskIQButton
          v-if="missing_component !== 'Microlearning'"
          :label="`Suggest ${missing_component}`"
        />
      </div>
    </div>
  </div>
</template>
  
<script setup>
  import AskIQButton from "@components/AskIQButton/AskIQButton.vue";
  import Icon from "@components/icons/Icon.vue";
  import Button from "@components/buttons/Button.vue";
  
  // Props definition
  const props = defineProps({
    missing_component: {
      type: String,
      default: "Instructions"
    }
  });

  // Emits
  const emit = defineEmits(['add-click']);

  const handleAddClick = () => {
    emit('add-click', props.missing_component);
  };
</script>
  
<style>
  .ex-checkpoint-banner {
    display: flex;
    background-color: #FFFFFF;
    border: 1px solid #D0D5DD;
    box-shadow: 0px 1px 2px 0px #1018280D;
    border-radius: 8px;
    padding: 10px 8px 12px 8px;
    flex-direction: row;
  }
  .ex-checkpoint-banner-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #EAECF0;
    box-shadow: 0px 1px 2px 0px #1018280D;
    padding: 10px 9px 9px 9.2px;
  }
  .ex-checkpoint-banner-right {
    position: relative;
    left: 15px;
  }
  .ex-checkpoint-banner-title {
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
    margin-bottom: 2px !important;
  }
  .ex-checkpoint-banner-description {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #475467;
    margin-bottom: 12px !important;
    width: 99%;
  }
  .banner-description {
    width: 100%;
  }
  .ex-checkpoint-banner-buttons {
    display: flex;
    gap: 12px;
    margin-top: -2px;
  }
  .banner-btns {
    font-weight: 600;
    background-color: #F2EDFF !important;
  }
  .add-instructions {
    width: 141px;
  }
  .add-microlearning {
    width: 196px;
  }
  .add-quiz {
    width: 90px;
  }
  .banner-btns:hover {
    background-color: #DACFF2 !important;
  }
</style>

